/**
 * Submission form copy constants.
 *
 * User-facing helper text for the submission create/display pages
 * (pages/submission/): image empty-state text and title/description hints.
 */
export const emptySubmissionImageText =
    "you need to add at least two images so the person can get a good idea of the item's details and condition";
export const submissionTitleMessage = "the most defining features";
export const submissionDescriptionMessage =
    "be as specific as possible here, add any critical details about the item like brand, size, age, flaws, etc.";
